import './onboarding.css';

import type React from 'react';
import type { Step } from 'react-joyride';
import Joyride from 'react-joyride';

import { onboardingTours } from './config';
import { CustomBeacon } from './custom-beacon';
import { CustomTooltip } from './custom-tooltip';
import {
  OnboardingProvider as ContextProvider,
  useOnboardingContext,
} from './onboarding-context';
import { PermissionsDockModal } from './permissions-dock-modal';
import { SurveyModal } from './survey-modal';
import { DEFAULT_JOYRIDE_PROPS } from './types';

interface OnboardingProviderProps {
  children: React.ReactNode;
}

const OnboardingJoyride: React.FC = () => {
  const {
    isRunning,
    stepIndex,
    handleJoyrideCallback,
    showPermissionsDock,
    handlePermissionsDockClose,
    showSurvey,
    surveyInstanceId,
    handleSurveyComplete,
    handleSurveyClose,
  } = useOnboardingContext();

  const currentTour = onboardingTours.find(tour => tour.id === 'pique-intro');
  const steps = currentTour?.steps || [];

  return (
    <>
      {showPermissionsDock && (
        <PermissionsDockModal onClose={handlePermissionsDockClose} />
      )}
      {showSurvey && (
        <SurveyModal
          key={surveyInstanceId}
          onClose={handleSurveyClose}
          onComplete={handleSurveyComplete}
        />
      )}
      <Joyride
        {...DEFAULT_JOYRIDE_PROPS}
        steps={steps as Step[]}
        run={isRunning}
        stepIndex={stepIndex}
        callback={handleJoyrideCallback}
        tooltipComponent={CustomTooltip}
        beaconComponent={CustomBeacon}
      />
    </>
  );
};

export const OnboardingProvider: React.FC<OnboardingProviderProps> = ({
  children,
}) => {
  return (
    <ContextProvider>
      <OnboardingJoyride />
      {children}
    </ContextProvider>
  );
};
